import { effect, inject, Injectable, signal } from '@angular/core';
import {
  ClientSessionService,
  UiSession,
} from '@brighthub/uisession';
import { GenericResponseCode } from '@brighthub/api';
import { ConversationService } from '@brighthub/brightnav-conversation-search';
import { EmployeeSearchService } from './employee-search.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeListService {

  activeConversation = signal<UiSession | null>(null);
  private _sessions = signal<UiSession[]>([]);
  sessions = this._sessions.asReadonly();
  private _loading = signal(false);
  public readonly loading = this._loading.asReadonly();
  private _clientSessionService = inject(ClientSessionService);
  private _conversationService = inject(ConversationService);
  private _employeeSearchService = inject(EmployeeSearchService);

  constructor() {
    effect(() => {
      const activeEmployee = this._employeeSearchService.activeEmployee();
      this.activeConversation.set(null);
    });
  }

  getSessionsByOktaId(oktaId: string): any {
    this._loading.set(true);
    this._clientSessionService.getUiSession(`?subjectType=client&oktaUserId=${oktaId}`)
      .subscribe({
        next: (resp) => {
          if (resp.result.code === GenericResponseCode.SERVICE_OK) {
            const sessions: UiSession[] = resp.payload.uiSessions;
            this._sessions.set(sessions);
            this._loading.set(false);
          }
        }
      });
  }

  getConversationById(conversationId: string): any {
    this._conversationService.getConversationById(conversationId);
  }

}
